import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NAVY = '#0A1F44';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate('/auth'), 2500);
    } catch (err) {
      setError(err.response?.data?.detail || 'Could not reset password. Please request a new link.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#F5F1E8' }}>
      <div className="w-full max-w-md bg-white rounded-3xl p-8 shadow-xl" data-testid="reset-password-page">
        <h1 className="text-2xl font-bold mb-4" style={{ color: NAVY, fontFamily: 'Outfit, sans-serif' }}>Choose a new password</h1>
        {!token && <p className="text-sm mb-4" style={{ color: '#b91c1c' }}>This link is missing its token. Please use the link from your email.</p>}
        {done ? (
          <p className="text-sm" style={{ color: '#166534' }} data-testid="reset-done">Password updated. Redirecting you to sign in…</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#94a3b8' }} />
              <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 8 chars)"
                data-testid="reset-password-input"
                className="w-full pl-9 pr-3 py-3 rounded-xl border outline-none" style={{ borderColor: '#e2e8f0', color: NAVY }} />
            </div>
            <div className="relative">
              <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2" style={{ color: '#94a3b8' }} />
              <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm new password"
                data-testid="reset-confirm-input"
                className="w-full pl-9 pr-3 py-3 rounded-xl border outline-none" style={{ borderColor: '#e2e8f0', color: NAVY }} />
            </div>
            {error && <p className="text-sm" role="alert" style={{ color: '#b91c1c' }} data-testid="reset-error">{error}</p>}
            <button type="submit" disabled={loading || !token} data-testid="reset-submit"
              className="w-full py-3 rounded-full font-bold text-white disabled:opacity-60" style={{ background: NAVY }}>
              {loading ? 'Updating…' : 'Reset password'}
            </button>
          </form>
        )}
        <Link to="/auth" className="block text-center text-sm mt-6" style={{ color: '#4a5568' }}>Back to sign in</Link>
      </div>
    </div>
  );
}
